<template>
    <div class="planTomorrow">
        <van-nav-bar
            title="明日计划"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <div class="select-wrapper">
            <!-- <div class="select-item">
                <div>
                    <span>{{ tomorrowTime }}</span>
                </div>
            </div> -->
            <div class="select-item">
                <div @click="startTimePicker = true">
                    <span>{{ tomorrowTime }}</span>
                    <i class="iconfont iconxiala"></i>
                </div>
            </div>
            <div
                class="select-item Station"
                @click="showPicker = true"
            >
                <span>{{ StationName }}</span>
                <i class="iconfont iconxiala"></i>
            </div>
        </div>
        <div class="main-wrapper">
            <div class="header-total">
                <ul class="total-list">
                    <li>
                        <p><i class="iconfont icontijikongjian"></i>总任务(个)</p>
                        <span>{{ totalCount.task_count || 0 }}</span>
                    </li>
                    <li>
                        <p><i class="iconfont icontijikongjian"></i>总任务方量(方)</p>
                        <span>{{ totalCount.task_volume || 0 }}</span>
                    </li>
                    <li class="active">
                        <p><i class="iconfont icontijikongjian"></i>剩余任务方量(方)</p>
                        <span>{{ totalCount.surplus_task_volume || 0 }}</span>
                    </li>
                </ul>
                <!-- 预计生产量统计 -->
                <div class="chart-box" v-show="showStationBar">
                    <div id="charts-station" class="charts-station">
                    </div>
                </div>
            </div>
            <section>
                <van-list
                    v-model="isUpLoading"
                    finished-text="没有更多了!"
                    :immediate-check="false"
                    :finished="finished"
                    @load="onLoad"
                >
                    <ul class="list">
                        <template v-for="(item, index) in listData">
                            <li :key="index">
                                <h4>
                                    <img src="@/assets/images/icons/icon_34.png" alt="">
                                    <span>任务编号：{{ item.task_number }}</span>
                                </h4>
                                <p>
                                    <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                    <span>订单编号：{{ item.order_number }}</span>
                                </p>
                                <p>
                                    <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                    <span>客户名称：{{ item.customer_name }}</span>
                                </p>
                                <p>
                                    <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                    <span>工程名称：{{ item.project_name }}</span>
                                </p>
                                <div>
                                    <p>
                                        <img src="@/assets/images/icons/icon_gy_5.png" alt="">
                                        <span>施工部位：{{ item.place_detail }}</span>
                                    </p>
                                    <p>
                                        <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                        <span>浇筑方式：{{ item.pouring_name }}</span>
                                    </p>
                                </div>
                                <div>
                                    <p>
                                        <img src="@/assets/images/icons/icon_gy_2.png" alt="">
                                        <span>供货站点：{{ item.station_name }}</span>
                                    </p>
                                    <p>
                                        <img src="@/assets/images/icons/icon_18.png" alt="">
                                        <span>计划方量：{{ item.plan_quantity }}</span>
                                    </p>
                                </div>
                                <div>
                                    <p>
                                        <img src="@/assets/images/icons/icon_32.png" alt="">
                                        <span>任务方量：{{ item.quantity }}</span>
                                    </p>
                                    <p>
                                        <img src="@/assets/images/icons/icon_32.png" alt="">
                                        <span>发货方量：{{ item.grand_total_complete_quantity }}</span>
                                    </p>
                                </div>
                                <div>
                                    <p>
                                        <img src="@/assets/images/icons/icon_38.png" alt="">
                                        <span>完成率(%)：{{ item.completion_rate }}</span>
                                    </p>
                                    <p>
                                        <img src="@/assets/images/icons/icon_30.png" alt="">
                                        <span>标号：{{ item.grade }}</span>
                                    </p>
                                </div>
                            </li>
                        </template>
                    </ul>
                </van-list>
            </section>
        </div>
        <!-- 时间控件 -->
        <van-popup
            v-model="startTimePicker"
            position="bottom"
            :overlay="true"
        >
            <van-datetime-picker
                v-model="startCurrentDate"
                type="date"
                title="选择年月日"
                @confirm="startConfirmData"
                @cancel="startTimePicker = false"
            ></van-datetime-picker>
        </van-popup>
        <!-- 选择场站 -->
        <van-popup
            v-model="showPicker"
            position="bottom"
        >
            <van-picker
                show-toolbar
                :columns="columns"
                @cancel="showPicker = false"
                @confirm="onConfirm"
            ></van-picker>
        </van-popup>
    </div>
</template>


<script>
import { Toast } from 'vant';
export default {
    // 明日计划
    name: 'plan-tomorrow',
    data() {
        return {
            // 明日时间
            tomorrowTime: '',
            // 时间控件默认日期
            startCurrentDate: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
            // 时间弹出层
            startTimePicker: false,
            // 场站弹出层状态
            showPicker: false,
            // 场站待选数据集合
            columns: [],
            // 场站名称
            StationName: '',
            // 场站id
            StationId: '',
            // 场站初始化数据待选数据
            StationData: [
                {
                    station_id: '',
                    station_name: '全部',
                },
            ],
            // 头部任务数据
            totalCount: {},
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 上拉索引
            count: 0,
            // 列表总条数
            total: 0,
            // 是否已加载完所有数据
            finished: false,
            // 列表数据
            listData: [],

            showStationBar: true,
        };
    },
    created() {
        // 初始化明日时间
        this.tomorrowTime = this.initDate();
        // 获取企业下所有场站
        this.getStationList();
        // 获取头部快数据
        this.getBlockData();
        // 获取列表数据
        this.gitListData();
    },
    watch: {
        StationId() {
            this.refreshData();
        },
    },
    mounted() {
        this.getStationChartsData();
    },
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        refreshData() {
            // 获取头部快数据
            this.getBlockData();
            this.count = 1;
            this.listData = [];
            this.finished = false;
            // 获取列表数据
            this.gitListData();
            this.getStationChartsData();
        },
        // 确认选择事件
        startConfirmData(val) {
            this.startTimePicker = false;
            this.tomorrowTime = this.formatDate(val);

            this.refreshData();
        },
        // 初始化明天日期
        initDate() {
            const newTime = new Date();
            newTime.setTime(newTime.getTime() + 24 * 60 * 60 * 1000);
            const time = newTime.getFullYear() + '-' + (newTime.getMonth() + 1) + '-' + newTime.getDate();
            return time;
        },
        // 时间格式化
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            let d = date.getDate();
            m = m < 10 ? '0' + m : m;
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        },
        // 获取企业下所有场站
        getStationList() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds.length > 0) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        station_name: stationNames[index],
                    };
                });
                this.StationData.push(...stationList);
                this.columns = this.StationData.map(item => item.station_name);
                this.StationName = this.columns[0];
                this.StationId = this.StationData[0].station_id;
            }
        },

        // 获取头部快数据
        getBlockData() {
            this.$axios
                .post('/interfaceApi/report/ProductTaskManager/tomorrow/plan/block', {
                    date: this.tomorrowTime,
                    mixstation_code: this.StationId,
                })
                .then(res => {
                    this.totalCount = res;
                })
                .catch(error => {
                    this.$toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        // 下拉刷新
        onRefresh() {
            this.count = 1;
            this.listData = [];
            this.finished = false;
            this.gitListData();
        },
        // 上拉加载更多
        onLoad() {
            this.count++;
            this.gitListData();
        },
        // 获取列表数据
        gitListData() {
            this.$axios
                .post('/interfaceApi/report/ProductTaskManager/tomorrow/plan/List', {
                    date: this.tomorrowTime,
                    mixstation_code: this.StationId,
                    pageindex: this.count,
                    pagesize: 4,
                })
                .then(res => {
                    if (res && res.rows.length > 0) {
                        this.total = res.total;
                        if (this.listData.length < 1 ) {
                            this.listData = res.rows;
                            this.finished = false;
                        } else {
                            res.rows.forEach(item => {
                                this.listData.push(item);
                            });
                        }
                        if (this.listData.length === this.total) {
                            this.finished = true;
                        }
                    } else {
                        this.finished = true;
                    }
                    this.isLoading = false;
                    this.isUpLoading = false;
                    this.$forceUpdate();
                })
                .catch(error => {
                    this.$toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },

        // 切换场站
        onConfirm(val, index) {
            this.showPicker = false;
            this.StationName = this.StationData[index].station_name;
            this.StationId = this.StationData[index].station_id;
        },
        // 获取场站预计生产量统计
        getStationChartsData() {
            // eslint-disable-next-line max-len
            this.$axios.get(`/interfaceApi/report/ProductTaskManager/tomorrow/plan/station?date=${this.tomorrowTime}&mixstation_code=${this.StationId}`)
                .then(data => {
                    if ((data || []).length > 0) {
                        this.showStationBar = true;
                        const chartData = {
                            id: 'charts-station',
                            title: '预计生产量',
                            legend: [],
                            xData: [],
                            yData: [],
                        };
                        data.forEach(item => {
                            chartData.xData.push(item.station_name);
                            chartData.yData.push(item.quantity);
                        });
                        this.$nextTick(() => {
                            this.initBarChart(chartData);
                        });

                    } else {
                        this.showStationBar = false;
                    }
                })
                .catch(error => {
                    this.$toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },

        initBarChart(data) {
            const myChart = this.$echarts.init(document.getElementById(data.id));
            const option = {
                title: {
                    text: data.title,
                    textStyle: {
                        color: '#979ea7',
                        fontSize: 14,
                        fontWeight: 'normal',
                    },
                },
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    data: data.legend,
                },
                grid: {
                    left: 30,
                    top: 40,
                    right: 20,
                    bottom: 20,
                },
                xAxis: [
                    {
                        type: 'category',
                        data: data.xData,
                        axisPointer: {
                            type: 'shadow',
                        },
                        // 设置间隔
                        axisLabel: {
                            interval: 0,
                            fontSize: 10, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                yAxis: [{
                    // 设置间隔
                    axisLabel: {
                        formatter: '{value}',
                        interval: 0,
                        fontSize: 12, // 字体大小
                    },
                    // 设置边框样式
                    axisLine: {
                        lineStyle: {
                            color: '#979EA7',
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed',
                            color: '#F0F0F0',
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                }],
                series: [{
                    name: '',
                    type: 'bar',
                    itemStyle: {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: '#5588f1', // 0% 处的颜色
                        }, {
                            offset: 1,
                            color: '#5588f1', // 100% 处的颜色
                        }], false),
                    },
                    label: {
                        show: false,
                        position: 'top',
                        fontSize: '12',
                        color: 'rgba(78,164,150,1)',
                        lineHeight: 22,
                        padding: [0, 10, 4, 10],
                    },
                    barMaxWidth: 15,
                    data: data.yData,
                }],
            };
            myChart.setOption(option);
        },
    },
};
</script>

<style lang="stylus">
.planTomorrow
    width 100%
    height 100%
    background #F0F0F0
    .select-wrapper
        position fixed
        width 90%;
        top 55rpx;
        left 0
        right 0
        margin 0 auto;
        height 45rpx
        box-shadow 0px 2px 8px 0px rgba(0, 0, 0, 0.16)
        border-radius 8px
        display flex
        background #fff;
        z-index 9;
        .select-item
            flex 1
            text-align center
            span
                font-size 14rpx
                font-weight 400
                line-height 45rpx
            i
                color #979EA7
            &:first-child
                flex 1
                display flex
                div
                    flex 1
                p
                    line-height 45rpx
                    color #979EA7
                    font-weight 400
        .Station
            position relative
            &:after
                content ''
                position absolute
                top 13rpx
                left 0
                height 20rpx
                border-left 2rpx solid #D7D7D7
            span
                color #3495FB
                padding-left 20rpx
    .main-wrapper
        height calc(100% - 45rpx)
        overflow-y auto;
        .header-total
            background #ffffff
            padding 15rpx
            padding-top 60rpx;
            .total-list
                display flex
                width 100%
                margin-top 15rpx
                li
                    flex 1
                    padding 0 4rpx
                    p
                        font-size 12rpx
                        color #979EA7
                        height 32rpx
                        // line-height 30rpx
                        text-align center
                        // display flex
                        // align-items center
                    span
                        width 100%
                        height 40rpx
                        background rgba(250,132,54,0.06)
                        display block
                        text-align center
                        line-height 40rpx
                        color #FA8436
                        font-size 18rpx
                    &:nth-child(2)
                        span
                            background rgba(85,136,241,0.06);
                            color #5588F1
                    &:nth-child(3)
                        span
                            background rgba(85,136,241,0.06);
                            color #5588F1
                    &:nth-child(4)
                        span
                            background rgba(33,189,204,0.06);
                            color #21BDCC
                    i
                        font-size 12rpx
                .active
                    span
                        background rgba(85,136,241,0.06)
                        border 2rpx solid rgba(205,221,254,1)
                        border-radius 6rpx
            .chart-box
                width 100%;
                .charts-station
                    margin-top 15rpx;
                    width 100%;
                    height 200rpx;
        section
            margin-top 15rpx
            .list
                li
                    width 100%
                    background #fff
                    overflow hidden
                    margin-bottom 15rpx
                    padding 15rpx 15rpx 0 15rpx
                    div
                        display flex
                        p
                            width 50%
                    img,span
                        display inline-block
                        height 16rpx
                        line-height 16rpx
                    img
                        width 16rpx
                        margin-right 5rpx
                    h4,p
                        overflow hidden
                    h4
                        margin-bottom 14rpx
                        img
                            vertical-align top
                            margin-top 2rpx
                        span
                            font-size 18rpx
                            line-height 20rpx
                            height 20rpx
                            color #061F3E
                            max-width calc(100% - 50rpx)
                    p
                        margin-bottom 14rpx
                        span
                            display inline-block
                            width calc(100% - 40rpx)
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                            font-size 14rpx
                            color #666666
                        &.weight
                            text-align right
                            img
                                float left
                            span
                                width calc((100% - 30rpx)/2)
                                text-align left
</style>
